function initPawTrail() {
  if (!window.matchMedia('(pointer: fine)').matches) return;

  const template = document.getElementById('tmpl-paw');
  if (!template) return;

  let lastX = 0, lastY = 0, lastT = 0, id = 0;

  document.addEventListener('mousemove', (e) => {
    const now = Date.now();
    const dx = e.clientX - lastX;
    const dy = e.clientY - lastY;
    const dist = Math.sqrt(dx * dx + dy * dy);

    if (dist < 70 || now - lastT < 80) return;

    const angle     = Math.atan2(dy, dx) * 180 / Math.PI - 90;
    const perpAngle = Math.atan2(dy, dx) + Math.PI / 2;
    const offset    = id % 2 === 0 ? 12 : -12;
    const x         = e.clientX + Math.cos(perpAngle) * offset;
    const y         = e.clientY + Math.sin(perpAngle) * offset;

    const paw = template.content.cloneNode(true).firstElementChild;
    paw.style.left      = (x - 8) + 'px';
    paw.style.top       = (y - 8) + 'px';
    paw.style.transform = 'rotate(' + angle + 'deg)';
    document.body.appendChild(paw);

    setTimeout(() => paw.remove(), 1500);

    lastX = e.clientX;
    lastY = e.clientY;
    lastT = now;
    id++;
  });
}

document.addEventListener('DOMContentLoaded', initPawTrail);
